/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Page, Content, Copy, BodyCopy } from '@insticator/insticator-ui'; // iui-material
import FlowControls from 'material/embeds/flowcontrols/flowcontrols_container'
import EmbedControls from 'material/embeds/embedcontrols/embedcontrols_container';
// placements
import RailPlacement from 'pages/dashboard/embeds/management/ads/placement/rail/rail_placement_container';
import InContentPlacement from 'pages/dashboard/embeds/management/ads/placement/incontent/incontent_placement_container';
import MobilePlacement from 'pages/dashboard/embeds/management/ads/placement/mobile/mobile_placement_container';
// video ads
import VideoAds from 'pages/dashboard/embeds/management/ads/videoads/videoads_container';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/ads/ads_styles';



/* ========== ~~~~~~~~~~ EMBED ADs ~~~~~~~~~~ ========== */
class AdsPage extends Component {
    isStep() {
        return this.props.currentStepPage !== null || this.props.currentStepPage !== undefined ? 'step' : 'standard';
    }
    showPlacement() {
        return this.props.location === 'in-content' ? <InContentPlacement/> : <RailPlacement/>;
    }
    /* /////////////// RENDER \\\\\\\\\\\\\\\ */
    render() {
        return(
            <Page name={`ads`} klass={`${this.props.classes.ads} ${this.isStep()}`}>
                <Content>
                    <EmbedControls handleSaveEmbed={this.props.handleSaveEmbed} />
                    <Copy>
                        <BodyCopy>
                            <p>Please select which <strong>Ad Slots</strong> you would like to run with your Embed</p>
                        </BodyCopy>
                    </Copy>
                    <div className={`placements`} >
                        {this.showPlacement()}
                        <MobilePlacement/>
                        {this.props.mocked ? <VideoAds /> : null}
                    </div>
                    <FlowControls handleSaveEmbed={this.props.handleSaveEmbed} />
                </Content>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(AdsPage);
